/* @flow */
import React from 'react';

const Error401 = () => (
  <div>
    <h1>CBD ID and version Number not Found.</h1>
    <h2>
      The cbd document may still be in the process of being generated.
      If you have any questions, please contact the site administrator.
    </h2>
  </div>
);

export default Error401;



// WEBPACK FOOTER //
// ./src/components/Errors/Error404.js